"use client"

import { Popover, PopoverPanel, Transition } from "@headlessui/react"
import { Fragment, useState } from "react"

import { ROUTES } from "@lib/routes"
import { useLastCheckoutProduct } from "@lib/util/checkout-cookie"
import LocalizedClientLink from "@modules/common/components/localized-client-link"
import Cart from "@modules/common/icons/cart"

import CartNotificationIndicator from "./components/cart-notification-indicator"
import EmptyCartDisplay from "./components/empty-cart-display"
import LastCheckoutProduct from "./components/last-checkout-product"

const CartDropdown = () => {
  const [cartDropdownOpen, setCartDropdownOpen] = useState(false)

  const open = () => setCartDropdownOpen(true)
  const close = () => setCartDropdownOpen(false)

  const lastProduct = useLastCheckoutProduct()

  return (
    <div className="z-50 h-full" onMouseEnter={open} onMouseLeave={close}>
      <Popover className="relative flex items-center justify-center outline-none">
        <LocalizedClientLink href={`/${ROUTES.CART}`} className="relative">
          <Cart size={30} color="#444444" />
          <CartNotificationIndicator />
        </LocalizedClientLink>

        <Transition
          show={cartDropdownOpen}
          as={Fragment}
          enter="transition ease-out duration-200"
          enterFrom="opacity-0 translate-y-1"
          enterTo="opacity-100 translate-y-0"
          leave="transition ease-in duration-150"
          leaveFrom="opacity-100 translate-y-0"
          leaveTo="opacity-0 translate-y-1"
        >
          <PopoverPanel
            static
            className="absolute right-0 top-[calc(100%+1px)] hidden w-[420px] rounded-xl border-x border-b border-gray-200 bg-white text-ui-fg-base small:block"
          >
            <div className="flex items-center justify-center p-4">
              <h3 className="text-large-semi">Carrito</h3>
            </div>
            {lastProduct ? <LastCheckoutProduct product={lastProduct} /> : <EmptyCartDisplay />}
          </PopoverPanel>
        </Transition>
      </Popover>
    </div>
  )
}

export default CartDropdown
